import { siteUrl, encUrl, siteDesc, encDesc, siteTitle, encTitle } from '@/lib/consts'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      siteUrl: siteUrl,
      encUrl: encUrl,
      siteDesc: siteDesc,
      encDesc: encDesc,
      siteTitle: siteTitle,
      encTitle: encTitle
    }
  },
  computed: {
    ...mapState( {
      demoCapable: state => state.demoCapable,
      didView: state => state.report.didView,
      mainColor: state => state.report.color,
      industry ( state ) {
        return typeof this.indOverride !== 'undefined'
          ? this.indOverride || state.report.industry
          : state.report.industry
      },
      reportTxtStyle: state => state.report.scrollSpeed,
      accent: state => state.report.accent,
      model: state => state.device.model,
      formFactor: state => state.device.formFactor,
      browser: state => state.device.browser,
      city: state => state.device.city,
      colorIdx: state => state.report.colorIdx,
      colors: state => [ state.report.color, state.report.accent ],
      colorsRev: state => [ state.report.accent, state.report.color ],
      reportLen: state => state.report.length,
      isFF: state => state.device.browser ? (state.device.browser.toLowerCase().includes( 'firefox' )) : false,
      isSafari: state => state.device.browser ? (state.device.browser.toLowerCase().includes( 'safari' )) : false,
      isEdge: state => state.device.browser ? (state.device.browser.toLowerCase().includes( 'edge' )) : false,
      isIE: state => state.device.browser ? (state.device.browser.toLowerCase().includes( 'explorer' )) : false,
      navHeight: 'navHeight',
      winH: 'winH',
      winW: 'winW',
      isMobile: 'isMobile',
      isSmall: 'isSmall',
      sideNavHeight: 'sideNavHeight',
      sideNavActiveIdx: 'sideNavActiveIdx',
      sideNavOnWhite: 'sideNavOnWhite',
      deskCtrlsHeight: 'deskCtrlsHeight',
      deskCtrlsOnWhite: 'deskCtrlsOnWhite'
    } ),
    isMS () {
      return (this.isEdge || this.isIE)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/mixins/StateMixin.js